import script from "./DictionaryModify.vue?vue&type=script&setup=true&lang=js"
export * from "./DictionaryModify.vue?vue&type=script&setup=true&lang=js"

import "./DictionaryModify.vue?vue&type=style&index=0&id=6c633537&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6c633537"]])

export default __exports__